export enum enumFileExtension {
  DOC = 'doc',
  DOCX = 'docx',
  GIF = 'gif',
  JPG = 'jpg',
  JPEG = 'jpeg',
  JSON = 'json',
  PNG = 'png',
  PDF = 'pdf',
  TXT = 'txt',
  XLS = 'xls',
  XLSX = 'xlsx',
  XML = 'xml',
  EML = 'eml',
}
